// extracted by mini-css-extract-plugin
module.exports = {"legalDocument":"LegalDocument_legalDocument__vCsP3"};